module.exports = __webpack_public_path__ + "img/doorLogo18.f099671a.png";